import Authority from '../views/CateManage/Authority';
import UserManger from '../views/CateManage/UserManger.vue';
import GroupManger from '../views/CateManage/GroupManger.vue';

let CateManage = [
  {
    path: 'Authority',
    name: '栏目权限管理',
    component: Authority,
    meta: {
      requireAuth: true
    }
  },
  {
    path: 'UserManger',
    name: '用户管理',
    component: UserManger,
    meta: {
      requireAuth: true
    }
  },
  {
    path: 'GroupManger',
    name: '用户组管理',
    component: GroupManger,
    meta: {
      requireAuth: true
    }
  }
];

export default CateManage;
